module.exports = __webpack_public_path__ + "static/media/Kangaskhan_gaussian2.050a2300.png";